import type { StatCardProps } from "@/components/molecules/StatCard";
import { Alarm, Profile2User, User } from "iconsax-react";

export interface User {
  id: string;
  name: string;
  email: string;
  age: number;
  gender: string;
  location: string;
  joined: string;
  status: "Active" | "Suspended";
  lastActive: string;
}

export interface ReportedUser {
  name: string;
  reports: number;
  lastReported: string;
}

export const USER_STATS: StatCardProps[] = [
  {
    title: "Total User",
    value: "12,745",
    icon: <User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Active Users (Last 7D)",
    value: "3,921",
    icon: <User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "decrease" },
  },
  {
    title: "New Signups (30D)",
    value: "3,000",
    icon: <User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Banned Users",
    value: "200",
    icon: <User variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Suspended Users",
    value: "125",
    icon: <Profile2User variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Reported Users",
    value: "190",
    icon: <Alarm variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+2", type: "increase" },
  },
];

export const MOCK_USERS: User[] = [
  {
    id: "1",
    name: "John Doe",
    email: "john@gmail.com",
    age: 28,
    gender: "male",
    location: "LA, USA",
    joined: "12 Mar 2025",
    status: "Active",
    lastActive: "12 Mar 2025",
  },
  {
    id: "2",
    name: "John Doe",
    email: "john@gmail.com",
    age: 28,
    gender: "male",
    location: "LA, USA",
    joined: "12 Mar 2025",
    status: "Active",
    lastActive: "12 Mar 2025",
  },
  {
    id: "3",
    name: "John Doe",
    email: "john@gmail.com",
    age: 28,
    gender: "male",
    location: "LA, USA",
    joined: "12 Mar 2025",
    status: "Active",
    lastActive: "12 Mar 2025",
  },
  {
    id: "4",
    name: "John Doe",
    email: "john@gmail.com",
    age: 28,
    gender: "male",
    location: "LA, USA",
    joined: "12 Mar 2025",
    status: "Active",
    lastActive: "12 Mar 2025",
  },
  {
    id: "5",
    name: "John Doe",
    email: "john@gmail.com",
    age: 28,
    gender: "male",
    location: "LA, USA",
    joined: "12 Mar 2025",
    status: "Active",
    lastActive: "12 Mar 2025",
  },
  {
    id: "6",
    name: "John Doe",
    email: "john@gmail.com",
    age: 28,
    gender: "male",
    location: "LA, USA",
    joined: "12 Mar 2025",
    status: "Active",
    lastActive: "12 Mar 2025",
  },
];

export const MOCK_REPORTED_USERS: ReportedUser[] = [
  {
    name: "Diana U.",
    reports: 3,
    lastReported: "Last 24h",
  },
  {
    name: "Diana U.",
    reports: 3,
    lastReported: "Last 24h",
  },
  {
    name: "Diana U.",
    reports: 3,
    lastReported: "Last 24h",
  },
  {
    name: "Diana U.",
    reports: 3,
    lastReported: "Last 24h",
  },
];

export const USER_TABLE_HEADERS = [
  "Name",
  "Email",
  "Age",
  "Gender",
  "Location",
  "Joined On",
  "Status",
  "Last Active",
  "",
];
